<template>
  <header>
    <v-app-bar
      dark
      color='#1D3557'
    >

      <v-app-bar-nav-icon color='#F1FAEE' @click="showDrawer"></v-app-bar-nav-icon>

      <v-toolbar-title>
        <v-img
          class="header-sp__logo"
          src="@/assets/coralpj_logo.png"
        ></v-img>
      </v-toolbar-title>

    </v-app-bar>

    <v-navigation-drawer
      v-model="drawer"
      absolute
      temporary
      dark
      color='#1D3557'
    >
      <v-list
        nav
        dense
      >
        <v-list-item-group>
          <v-list-item
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :href="menuItem.id"
            @click="showDrawer"
          >
              <!-- <router-link :to="menuItem.id">{{ menuItem.name }}</router-link> -->
              <!-- <a :href="menuItem.id" class="header-sp__tab" @click="showDrawer">
                {{ menuItem.name }}
              </a> -->
            {{ menuItem.name }}
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>
  </header>
</template>

<script>
import constants from '../common/constants'

export default {
  name: 'AppHeader',
  data () {
    return {
      drawer: false,
      menuItems: constants.spMenuItems
    }
  },
  methods: {
    showDrawer () {
      this.drawer = !this.drawer
      console.log('@click')
    }
  }
}
</script>

<style lang="scss" scoped>
.header-sp__logo {
  max-width: 200px;
}
.header-sp__tab {
  // font-weight: bold;
  // text-decoration: none;
  // color: #F1FAEE;
}
</style>
